import { signal } from '@preact/signals-react'
import tokenService, { AuthSecretProps } from '../utils/tokenService'

type TUser = any

export const accessToken = signal<string>('')
export const refreshToken = signal<string>('')
export const user = signal<TUser>(null)

export function authLoad() {
    const secret = tokenService.getSecret()

    accessToken.value = secret?.accessToken || ''
    refreshToken.value = secret?.refreshToken || ''
    user.value = secret?.user || null

    return secret
}

export function authLogin(secret: AuthSecretProps) {
    accessToken.value = secret.accessToken
    refreshToken.value = secret.refreshToken
    user.value = secret.user

    tokenService.setSecret(secret)
}

export function authLogout() {
    accessToken.value = ''
    refreshToken.value = ''
    user.value = null

    tokenService.removeSecret()
}
